export type DocumentStatus = {
  id: string;
  code?: string;
  name?: string;
  status: number | null;
  statusString?: string;
  isFromManager: boolean;
  isActive?: boolean;
  selected?: boolean;
};

export enum eDocumentStatus {
  Open = 0,
  InProgress = 1,
  Hold = 2,
  Closed = 3,
}
